module.exports = __webpack_public_path__ + "static/media/sensorsLight.92fb762a.svg";